module.exports = __webpack_public_path__ + "static/media/quote-icon.7c89a22a.svg";